module.exports = __webpack_public_path__ + "img/step-1@2x.50c5f5e7.png";